export default __webpack_public_path__ + "static/media/BMW_Group_Grey.b458e0a0.svg";